import ConsolaLupa from './consola-lupa';
export default ConsolaLupa;